import { useQuery } from '@tanstack/react-query';
import { DepotParam, fetchDepot } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDepot = (id: number) =>
  useQuery<(DepotParam & { id: number }) | undefined>({
    queryFn: async () => {
      const result = await extractData(fetchDepot({ path: { id } }));
      return result.depot as (DepotParam & { id: number }) | undefined;
    },
    queryKey: ['depots', id],
  });
